import React, { useEffect, useState, useCallback } from "react";
import Swal from "sweetalert2";
import { HelpHttp } from "helpers/HelpHttp";
import { HelpFunctions } from "helpers/HelpFunctions";
import { trackPromise } from "react-promise-tracker";
import axios from "axios";

const { REACT_APP_API } = process.env;

const MinPrePostService = ({ service }) => {
    console.log("Aqui entro service" + service);

    const [parameters, setParameters] = useState([]);
    const [success, setSuccess] = useState("");
    const [timeout, setTimeout] = useState("")
    const [codError, setCodError] = useState("");
    const [trama, setTrama] = useState({});

    let api = HelpHttp();
    let f = HelpFunctions();

    const urlTrama = `${REACT_APP_API}/parameters/findTrama`;
    const url = `${REACT_APP_API}/parameters/findAllByService/${service.code}`;

    const getParameters = async () => {
        //setLoading(true);
        trackPromise(api.get(url).then(res => {
            //setLoading(false);
            if (res.err) {
                setParameters(null);
                // setRequestError(res);
            } else {
                setParameters(res);
                console.log("Aqui entro" + parameters);
                res.forEach(par => {
                    (par.parameter === "success") ? setSuccess(par.value) : setTimeout(par.value)
                })
            }
        }));
    }

    async function updateParamAuthenticationOtpService() {
        let data1 = {};
        let data2 = {};
        let error;
        parameters.forEach(par => {
            if (par.parameter === 'success') {
                data1.service = service.code;
                data1.parameter = 'success';
                data1.value = success;
                data1.cod_error = '';
                if (success === 'false') {
                    if (!codError) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: "¡Ingrese un tipo de error!"
                        });
                        error = true;
                    }
                    data1.cod_error = codError
                }
            } else {
                data2.service = service.code
                data2.parameter = 'timeout'
                data2.value = timeout
            }
        })

        if (error) 
            return null;
        
        const resp1 = await f.updateParam(data1);
        if (resp1.err) {
            //setRequestError(res);
        } else {
            if (resp1.success) {
                // Swal.fire('¡Ok!', '¡Datos actualizados con exito!', 'success');
                // await getParamAuthenticationOtpService();
                const resp2 = await f.updateParam(data2);
                if (resp2.err) {
                    //setRequestError(res);
                } else {
                    if (resp2.success) {
                        Swal.fire('¡Ok!', '¡Datos actualizados con exito!', 'success');
                        await getParameters();
                    } else {
                        Swal.fire('¡Ok!', `¡${resp2.message}!`, 'warning');
                    }
                }
            } else {
                Swal.fire('¡Ok!', `¡${resp1.message}!`, 'warning');
            }
        }
    }

    const getTrama = useCallback(async (url) => {
        let { data } = await axios.post(url, parameters);
        console.log({ data });
        setTrama(data);
    }, [parameters]);

    useEffect(() => {
        getParameters();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!parameters.length) return;

        const parameterSuccess = parameters.find(
            (param) => param.parameter === "success" && (param.value === "false" || param.value === "true")
        );

        if (parameterSuccess) {
            setCodError(parameterSuccess.cod_error);
        }

        console.log("Obteniendo trama");
        getTrama(urlTrama);
    }, [parameters, getTrama, urlTrama]);

    return (
        <>
            {parameters &&
                <div className="card ">
                    <h5 className="card-header">{service.name} <small style={{ fontWeight: "normal" }} className="text-muted">{service.endpoint || "Sin Ruta"}</small></h5>
                    <div className="card-body">
                        <p className="card-text">{service.description}</p>
                        <fieldset className="row mb-3">
                            <legend className="col-form-label col-sm-3 pt-0">Parámetro Success:</legend>
                            <div className="col-sm-9">
                                <div className="form-check">
                                    <div className="row">
                                        <div className="col-sm-2">
                                            <input type="radio" className="form-check-input" id="rad_Success_true"
                                                checked={success === 'true'} name="radioSuccess" value="true"
                                                onChange={(e) => setSuccess(e.target.value)} />
                                            <label htmlFor="rad_Success_true"
                                                className="form-check-label">True</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-check">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <input type="radio" className="form-check-input" id="rad_Success_false"
                                                checked={success === 'false'} name="radioSuccess" value="false"
                                                onChange={(e) => setSuccess(e.target.value)} />
                                            <label htmlFor="rad_Success_false"
                                                className="form-check-label">False</label>
                                        </div>
                                        {success === 'false' &&
                                            <>
                                                <div className="col-sm-6">
                                                    <div className="mb-2">
                                                        <label htmlFor="codError">Tipo de Error</label>
                                                        <select className="form-select form-select-sm"
                                                            onChange={(e) => setCodError(e.target.value)} name="codError" id="codError" value={codError}>
                                                            <option value="">Seleccione...</option>
                                                            <option value="400">Error de campos no validos</option>
                                                            <option value="500">Fallido Error del Microservicio</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {success === 'true' &&
                                            <>
                                                <div className="col-sm-6">
                                                    <div className="mb-2">
                                                        <label htmlFor="codSucess">Tipo de Success</label>
                                                        <select className="form-select form-select-sm"
                                                            onChange={(e) => setCodError(e.target.value)} name="codError" id="codError" value={codError}>
                                                            <option value="">Seleccione...</option>
                                                            <option value="CN-002">Exitoso HTTP 201 Aplica restricción</option>
                                                            <option value="CN-007">Exitoso HTTP 201 Aplica restricción Robo / Perdida</option>
                                                            <option value="CN-008">Exitoso HTTP 201 - Validación de Titularidad no exitosa</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset className="row mb-3">
                            <legend className="col-form-label col-sm-3 pt-0">Parámetro Timeout:</legend>
                            <div className="col-sm-9">
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="rad_TimeOut_true"
                                        checked={timeout === 'true'} name="radioTimeOut" value="true"
                                        onChange={(e) => setTimeout(e.target.value)} />
                                    <label htmlFor="rad_TimeOut_true">True</label><br />
                                </div>
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="rad_TimeOut_false"
                                        checked={timeout === 'false'} name="radioTimeOut" value="false"
                                        onChange={(e) => setTimeout(e.target.value)} />
                                    <label htmlFor="rad_TimeOut_false">False</label><br />
                                </div>
                            </div>
                        </fieldset>
                        <button type="submit" className="btn btn-primary"
                            onClick={updateParamAuthenticationOtpService}><i className="bi bi-save2" /> Actualizar
                        </button>
                    </div>
                    <div className="card bg-light mt-2" id="trama">
                        <div className="card-body">
                            <h6>Request:</h6>
                            <pre>
                                <code>{JSON.stringify(trama.request, null, 2)}</code>
                            </pre>
                        </div>
                    </div>
                    <div className="card bg-light mt-2" id="trama">
                        <div className="card-body">
                            <h6>Response:</h6>
                            <pre>
                                <code>{JSON.stringify(trama.content, null, 2)}</code>
                            </pre>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default MinPrePostService